import React, { useState, useEffect } from 'react';
import { BringzzButton, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzInput,
    BringzzCountryDropdown,
    BringzzDate,
    BringzzPageContainer,
    BringzzIcon,
    BringzzRadio,
    BringzzBottomDrawer,
    BringzzRadioList,
    BringzzMultiSelect,
    BringzzCheck
} from "@bringzz/components";
import { useLocation } from 'react-router-dom';
import { Mode } from "@bringzz/components";
import useRequest from 'hooks/useRequest';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

let state = {
    checked: (
        <BringzzIcon
            icon="IconCheck"
            library="Custom"
            className="h-5 w-5 p-1 bg-magic-lilac text-light rounded-full"
            size="12"
        />
    ),
    unChecked: (
        <div></div>
    ),
};

const ConsumerProfilePage = () => {
    const { backPress, navigate } = useNavigation();
    const { sendRequest, data, error, loading } = useRequest();
    const { continueSignup } = useAuth();
    const { t } = useTranslation();

    let query = useQuery();
    const userId = query.get('userId');
    const method = query.get('method');
    const value = query.get('value');
    const firstNameParam = query.get('firstName');
    const lastNameParam = query.get('lastName');
    const profilePictureParam = query.get('profilePicture');

    const defaultMedicalSpecialties = ["Allergy", "Anesthesiology", "Cardiology", "Diabetes", "Deficiency", "Dermatology", "Disability", "Emergency"]
    const [medicalSpecialties, setMedicalSpecialties] = useState(defaultMedicalSpecialties)
    const [selectedMedicalSpecialties, setSelectedMedicalSpecities] = useState(null)

    const [genderDrawerOpened, setGenderDrawerOpened] = useState(false)
    const [selectedGender, setSelectedGender] = useState(null)

    const [titleDrawerOpened, setTitleDrawerOpened] = useState(false)
    const [selectedTitle, setSelectedTitle] = useState(null)

    const [birthdayDrawerOpened, setBirthdayDrawerOpened] = useState(false)
    const [selectedBirthday, setSelectedBirthday] = useState(null)

    const [doctorDrawerOpened, setDoctorDrawerOpened] = useState(false)
    const [medicalSpecialtyOpened, setMedicalSpecialtyOpened] = useState(false)

    const [country, setCountry] = useState({
        name: 'Austria',
        dial_code: '+43',
        code: 'AT'
    });
    const [identifier, setIdentifier] = useState(null)
    const [email, setEmail] = useState(null)
    const [firstName, setFirstName] = useState(null)
    const [lastName, setLastName] = useState(null)
    const [SVNumber, setSVNumber] = useState('')
    const [formValid, setFormValid] = useState(false)
    const [doctorId, setDoctorId] = useState(null);
    const [doctorUid, setDoctorUid] = useState(null);
    const [doctorType, setDoctorType] = useState(null);
    const [doctorCard, setDoctorCard] = useState(null);
    const [doctorCardPreview, setDoctorCardPreview] = useState(null);
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleMultiSelectChange = (selectedValues) =>
        setSelectedMedicalSpecities(selectedValues)

    useEffect(() => {
        if (firstNameParam) {
            setFirstName(decodeURIComponent(firstNameParam));
        }
        if (lastNameParam) {
            setLastName(decodeURIComponent(lastNameParam));
        }
    }, [firstNameParam, lastNameParam]);

    const validateForm = () => {
        const contactValid = method === 'email' ? identifier : email;
        return contactValid && selectedGender && firstName && lastName && selectedBirthday;
    }

    const returnGenderLabel = (selectedIndex) => {
        if (selectedIndex == "0") {
            return t('component.auth.consumer.profile.gender.male')
        } else if (selectedGender == "1") {
            return t('component.auth.consumer.profile.gender.female')
        } else {
            return t('component.auth.consumer.profile.gender.diverse')
        }
    }

    const handleRemoveSpecialty = (specialtyToRemove) => {
        setSelectedMedicalSpecities(selectedMedicalSpecialties.filter(specialty => specialty !== specialtyToRemove));
    };

    const registerCostumer = async () => {
        const formData = new FormData();
        formData.append('userId', userId);
        if (method === 'email') {
            formData.append('phoneNumber', `${country.dial_code}${identifier}`);
            formData.append('emailAddress', decodeURIComponent(value));
        } else {
            formData.append('phoneNumber', decodeURIComponent(value));
            formData.append('emailAddress', email);
        }
        formData.append('gender', selectedGender);
        formData.append('title', selectedTitle);
        formData.append('firstname', firstName);
        formData.append('lastname', lastName);
        formData.append('svNumber', SVNumber);
        formData.append('birthday', selectedBirthday);
        formData.append('language', "en");
        if (doctorId) formData.append('doctorId', doctorId);
        if (doctorUid) formData.append('doctorUid', doctorUid);
        const doctorType = selectedMedicalSpecialties?.join(', ') || null;
        if (doctorType) formData.append('doctorType', doctorType);
        if (doctorCard) formData.append('doctorCard', doctorCard);
    
        const result = await sendRequest({
            method: 'POST',
            url: `/module/user/registerCustomer`,
            data: formData,
            headers: {
                'Content-Type': undefined
            }
        })
        .then(response => {
            if (response.status === 'success') {
                return response;
            }
        })
        .catch(error => {
            console.error(error);
            return false;
        });
    
        if (result) {
            await continueSignup(result.data.token);
            const nextUrl = profilePictureParam
                ? `/register/consumer/picture?profilePicture=${encodeURIComponent(profilePictureParam)}`
                : `/register/consumer/picture`;
            navigate(nextUrl);
        }
    };
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setDoctorCardPreview(reader.result);
                setUploadedFileName(file.name);
            };
            reader.readAsDataURL(file);
            setDoctorCard(file); // Store the actual file object
        }
    };

    return (
        <BringzzPageContainer
            className="bg-white"
            steps={true}
            activeStep={1}
            header={{
                left: (
                    <div className='flex items-center cursor-pointer' onClick={() => navigate('/')}>
                        <BringzzIcon
                            size='22'
                            icon='IconChevronLeft'
                            folder='LineIcons'
                        />
                        <BringzzText tag='h4'>{t('common.back')}</BringzzText>
                    </div>
                ),
                title: t('component.auth.consumer.profile.header.title')
            }}
            footer={
                <div className='pb-8 px-6'>
                    <BringzzButton
                        size='lg'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        onClick={async () => {
                            await registerCostumer()
                        }}
                        disabled={!validateForm() || loading}
                    >
                        {t('common.continue')}
                    </BringzzButton>
                </div >
            }
            authenticated={false}
        >
            <div className='relative flex justify-center bg-magic-lilac/20'>
                <div className='relative bg-white w-full bg-cover bg-center flex flex-col'>
                    {/* Content */}
                    <div className='flex-grow flex flex-col py-8 px-4'>
                        <div className='z-10 flex flex-col '>
                            <div className='pl-2 flex flex-col space-y-6 md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
                                <BringzzText tag='h1' className='pl-2 text-midnight-blue font-bold'>
                                    <div className='flex flex-col'>
                                        <div>{t('component.auth.consumer.profile.title.setup')}</div>
                                        <div>{t('component.auth.consumer.profile.title.your_account')}</div>
                                    </div>
                                </BringzzText>
                            </div>
                            <div className='space-y-6 mt-12'>
                                <div className='space-y-4'>

                                    {method === 'email' ? (
                                        <BringzzInput 
                                            onChange={(newValue) => setIdentifier(newValue.target.value)} 
                                            label={t('component.auth.consumer.profile.labels.phone_number') + ' *'} 
                                            placeholder={t('component.auth.consumer.profile.labels.phone_number')}
                                            className="!pl-16"
                                            icon={{
                                                left: <BringzzCountryDropdown
                                                    className="!rounded-r-none"
                                                    mode={'modal'}
                                                    onCountryChange={result => {
                                                        setCountry(result);
                                                    }}
                                                />
                                            }}
                                        />
                                    ) : (
                                        <BringzzInput 
                                            onChange={(newValue) => setEmail(newValue.target.value)} 
                                            label="Email Address *" 
                                            placeholder="Enter your email address"
                                            type="email"
                                        />
                                    )}

                                    <div className='flex gap-2'>
                                        <BringzzInput
                                            label={t('component.auth.consumer.profile.labels.gender') + ' *'}
                                            placeholder={selectedGender ? returnGenderLabel(selectedGender) : t('component.auth.consumer.profile.placeholders.select')}
                                            type="text"
                                            readOnly={true}
                                            className='cursor-pointer'
                                            containerClassname='w-full'
                                            icon={{
                                                right: <BringzzIcon
                                                    icon="IconChevronDown"
                                                    library="Custom"
                                                    className="h-5 w-5 p-1 text-midnight-blue rounded-full"
                                                    size="12"
                                                />
                                            }}
                                            onClick={() => setGenderDrawerOpened(true)} />
                                        <BringzzInput
                                            label={t('component.auth.consumer.profile.labels.title')}
                                            placeholder={selectedTitle ? selectedTitle : t('component.auth.consumer.profile.placeholders.select')}
                                            type="text"
                                            readOnly={true}
                                            className='cursor-pointer'
                                            containerClassname='w-full'
                                            icon={{
                                                right: <BringzzIcon
                                                    icon="IconChevronDown"
                                                    library="Custom"
                                                    className="h-5 w-5 p-1 text-midnight-blue rounded-full"
                                                    size="12"
                                                />
                                            }}
                                            onClick={() => setTitleDrawerOpened(true)} />
                                    </div>

                                    <div className='flex gap-2'>
                                        <BringzzInput value={firstName} onChange={(newValue) => setFirstName(newValue.target.value)} label={t('component.auth.consumer.profile.labels.first_name') + ' *'} containerClassname="w-full" placeholder={t('component.auth.consumer.profile.placeholders.first_name')} />
                                        <BringzzInput value={lastName} onChange={(newValue) => setLastName(newValue.target.value)} label={t('component.auth.consumer.profile.labels.last_name') + ' *'} containerClassname="w-full" placeholder={t('component.auth.consumer.profile.placeholders.last_name')} />
                                    </div>

                                    <div className='flex gap-2'>
                                        <BringzzInput onChange={(newValue) => setSVNumber(newValue.target.value)} containerClassname="w-full" label={t('component.auth.consumer.profile.labels.sv_number')} tooltip={t('component.auth.consumer.profile.tooltips.sv_number')} placeholder="1234" />
                                        <div className='space-y-[1px] w-full'>
                                            <BringzzText tag="h3">{t('component.auth.consumer.profile.labels.birthday')} *</BringzzText>
                                            <BringzzDate
                                                placeholder={selectedBirthday ? selectedBirthday : "06/05/2024"}
                                                format="dd/MM/yyyy"
                                                onChange={(newDate) => setSelectedBirthday(newDate)}
                                                mode={Mode.DAY}
                                                maxDate={new Date()}
                                            ></BringzzDate>
                                        </div>

                                    </div>

                                    <div className='flex justify-center align-center pt-6 space-x-2'>
                                        <BringzzText tag="h3" className="font-normal">{t('component.auth.consumer.profile.doctor.question')}</BringzzText>
                                        <div>&bull;</div>
                                        <BringzzText tag="h3" className="underline font-bold text-midnight-blue cursor-pointer" onClick={() => setDoctorDrawerOpened(true)}>{t('component.auth.consumer.profile.doctor.verify_here')}</BringzzText>
                                    </div>

                                    <BringzzBottomDrawer
                                        isOpen={genderDrawerOpened}
                                        close={() => setGenderDrawerOpened(false)}
                                        title={t('component.auth.consumer.profile.drawers.select_gender')}
                                    >
                                        <div className='px-4 py-6'>
                                            <BringzzRadioList
                                                onChange={(newValue) => {
                                                    console.log(newValue);
                                                    setSelectedGender(newValue)
                                                }}
                                                state={state}
                                                className="rounded-xl w-full text-center"
                                            >
                                                <BringzzRadio value="0"
                                                    className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400 flex"
                                                >
                                                    <div>
                                                        {t('component.auth.consumer.profile.gender.male')}
                                                    </div>
                                                </BringzzRadio>
                                                <BringzzRadio value="1"
                                                    className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400">
                                                    <div>
                                                        {t('component.auth.consumer.profile.gender.female')}
                                                    </div>
                                                </BringzzRadio>
                                                <BringzzRadio className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400" value="2">
                                                    <div>{t('component.auth.consumer.profile.gender.diverse')}</div>
                                                </BringzzRadio>
                                            </BringzzRadioList>
                                        </div>

                                        <div className='text-center mb-12 px-4'>
                                            <BringzzButton
                                                className='bg-magic-lilac w-full flex justify-center'
                                                onClick={() => {
                                                    console.log();
                                                    setGenderDrawerOpened(false)
                                                }}
                                            >
                                                {t('common.confirm')}
                                            </BringzzButton>
                                        </div>
                                    </BringzzBottomDrawer>

                                    <BringzzBottomDrawer
                                        isOpen={titleDrawerOpened}
                                        close={() => setTitleDrawerOpened(false)}
                                        title={t('component.auth.consumer.profile.drawers.select_title')}
                                    >
                                        <div className='px-4 py-6'>
                                            <BringzzRadioList
                                                onChange={(newValue) => {
                                                    setSelectedTitle(newValue)
                                                }}
                                                state={state}
                                                className="rounded-xl w-full text-center"

                                            >
                                                <BringzzRadio value="Mag."
                                                    className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400 flex"
                                                >
                                                    <div>
                                                        Mag.
                                                    </div>
                                                </BringzzRadio>
                                                <BringzzRadio value="Dr."
                                                    className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400">
                                                    <div>
                                                        Dr.
                                                    </div>
                                                </BringzzRadio>
                                                <BringzzRadio className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400" value="Prof.">
                                                    <div>Prof</div>
                                                </BringzzRadio>
                                                <BringzzRadio className="p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400" value="BA.">
                                                    <div>BA</div>
                                                </BringzzRadio>
                                            </BringzzRadioList>
                                            <div>
                                                <BringzzInput placeholder={t('component.auth.consumer.profile.placeholders.custom_title')} onChange={(e, newIsValid, newValue) => {
                                                    setSelectedTitle(newValue)
                                                }}></BringzzInput>
                                                <BringzzText className='mt-1 font-normal' tag='h5'>{t('component.auth.consumer.profile.help.custom_title')}</BringzzText>
                                            </div>
                                        </div>

                                        <div className='text-center mb-12 px-4'>
                                            <BringzzButton
                                                className='bg-magic-lilac w-full flex justify-center'
                                                onClick={() => {
                                                    setTitleDrawerOpened(false)
                                                }}
                                            >
                                                {t('common.confirm')}
                                            </BringzzButton>
                                        </div>
                                    </BringzzBottomDrawer>

                                    <BringzzBottomDrawer
                                        isOpen={birthdayDrawerOpened}
                                        close={() => setBirthdayDrawerOpened(false)}
                                        title={t('component.auth.consumer.profile.drawers.select_birthday')}
                                    >
                                        <div className='px-4 py-6'>

                                        </div>

                                        <div className='text-center mb-12 px-4'>
                                            <BringzzButton
                                                className='bg-magic-lilac w-full flex justify-center'
                                                onClick={() => {
                                                    console.log();
                                                    setBirthdayDrawerOpened(false)
                                                }}
                                            >
                                                {t('common.confirm')}
                                            </BringzzButton>
                                        </div>
                                    </BringzzBottomDrawer>
                                </div>

                            </div>
                        </div>
                    </div>
                    <BringzzBottomDrawer isOpen={doctorDrawerOpened} title={t('component.auth.consumer.profile.doctor.verification_title')} close={() => setDoctorDrawerOpened(false)}>
                        <div className='p-4 space-y-4'>
                            {/* Doctor ID Input */}
                            <BringzzInput 
                                label={t('component.auth.consumer.profile.doctor.labels.doctor_id')} 
                                placeholder={t('component.auth.consumer.profile.doctor.placeholders.doctor_id')} 
                                onChange={(e) => setDoctorId(e.target.value)}
                            />

                            {/* Medical Specialty = Doctor Type */}
                            {!selectedMedicalSpecialties ? 
                                <BringzzInput 
                                    label={t('component.auth.consumer.profile.doctor.labels.medical_specialty')} 
                                    placeholder={t('component.auth.consumer.profile.doctor.placeholders.medical_specialty')} 
                                    tooltip="something"
                                    readOnly={true}
                                    className='cursor-pointer'
                                    containerClassname='w-full'
                                    icon={{
                                        right: <BringzzIcon
                                            icon="IconChevronDown"
                                            library="LineIcons"
                                            className="h-5 w-5 p-1 text-midnight-blue rounded-full"
                                            size="12"
                                        />
                                    }}
                                    onClick={() => setMedicalSpecialtyOpened(true)}
                                /> : 
                                <div>
                                    <div className='flex mb-2'>
                                        <BringzzText tag="h4">{t('component.auth.consumer.profile.doctor.labels.medical_specialty_short')}</BringzzText>
                                        <div className="ml-1 relative group">
                                            <BringzzIcon
                                                icon="IconQuestionCircle"
                                                folder="LineIcons"
                                                className="h-4 w-4 cursor-pointer text-magic-lilac"
                                                size="16"
                                            />
                                        </div>
                                    </div>
                                    <div className='flex flex-wrap space-x-2 space-y-1 items-center'>
                                        {selectedMedicalSpecialties.map((specialty, index) => (
                                            <div 
                                                key={index} 
                                                className='bg-sand p-1 flex cursor-pointer items-center space-x-1'
                                                onClick={() => handleRemoveSpecialty(specialty)}
                                            >
                                                <BringzzText tag='h5' className="font-normal">{specialty}</BringzzText>
                                                <BringzzIcon
                                                    icon="IconPlus"
                                                    folder="LineIcons"
                                                    className='cursor-pointer rotate-45'
                                                    size="11"
                                                />
                                            </div>
                                        ))}
                                        <BringzzIcon
                                            icon="IconPlus"
                                            folder="LineIcons"
                                            className='cursor-pointer'
                                            size="11"
                                            onClick={() => setMedicalSpecialtyOpened(true)}
                                        />
                                    </div>
                                </div>
                            }

                            <BringzzInput 
                                label={t('component.auth.consumer.profile.doctor.labels.uid_number')} 
                                placeholder="ATU12345678" 
                                onChange={(e) => setDoctorUid(e.target.value)}
                            />
                            <div>
                                <div className='flex'>
                                    <BringzzText tag="h4">{t('component.auth.consumer.profile.doctor.labels.id_card')}</BringzzText>
                                    <div className="ml-1 relative group">
                                        <BringzzIcon
                                            icon="IconQuestionCircle"
                                            folder="LineIcons"
                                            className="h-4 w-4 cursor-pointer text-magic-lilac"
                                            size="16"
                                        />
                                    </div>
                                </div>

                                <div className='mt-2 bg-slate-100 h-40 rounded-lg flex flex-col justify-center items-center'>
                                    <input
                                        type="file"
                                        hidden
                                        id="doctorCardUpload"
                                        accept="image/*"
                                        onChange={handleFileUpload}
                                    />
                                    {doctorCardPreview ? (
                                        <>
                                            <img 
                                                src={doctorCardPreview} 
                                                alt="Uploaded ID Card" 
                                                className="h-32 w-auto mb-2 object-contain"
                                            />
                                            <BringzzText tag="h5" className="text-sm">{uploadedFileName}</BringzzText>
                                        </>
                                    ) : (
                                        <BringzzButton 
                                            size="lg" 
                                            className="bg-midnight-blue text-white" 
                                            icon={{ variant: "IconEuroCard", folder: "LineIcons", size: "16" }}
                                            onClick={() => document.getElementById('doctorCardUpload').click()}
                                        >
                                            {t('component.auth.consumer.profile.doctor.buttons.upload')}
                                        </BringzzButton>
                                    )}
                                </div>
                            </div>

                            <BringzzText tag='h5'>{t('component.auth.consumer.profile.doctor.help.verification_info')}</BringzzText>

                            <BringzzButton 
                                className="bg-magic-lilac w-full flex justify-center"
                                onClick={() => setDoctorDrawerOpened(false)}
                            >
                                {t('common.confirm')}
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>

                    <BringzzBottomDrawer isOpen={medicalSpecialtyOpened} title={t('component.auth.consumer.profile.doctor.drawers.select_specialty')} close={() => setMedicalSpecialtyOpened(false)}>
                        <div className='p-4 space-y-3'>
                            <BringzzText tag='h5' className="font-normal">{t('component.auth.consumer.profile.doctor.help.select_specialty')}</BringzzText>
                            <BringzzMultiSelect
                                onChange={(selected) => {
                                    handleMultiSelectChange(selected);
                                    setDoctorType(selected.join(', ')); // Convert array to string
                                }}
                                state={{ checked: state.checked, unChecked: state.unChecked }}
                                className="divide-y"
                            >
                                {medicalSpecialties.map((specialty, index) => (
                                    <BringzzCheck key={index} value={specialty}>{specialty}</BringzzCheck>
                                ))}
                            </BringzzMultiSelect>
                            <BringzzInput 
                                onEnterPress={(newValue) => {
                                    setMedicalSpecialties([newValue, ...medicalSpecialties]);
                                    setDoctorType(prev => prev ? `${prev}, ${newValue}` : newValue);
                                }} 
                                placeholder='Other medical speciality'
                            />
                            <BringzzText tag='h5'>Please enter your medical specialty, in case it is not listed</BringzzText>
                            <BringzzButton
                                className='bg-magic-lilac w-full flex justify-center'
                                onClick={() => setMedicalSpecialtyOpened(false)}
                                disabled={!selectedMedicalSpecialties}
                            >
                                Confirm
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>
                    <BringzzBottomDrawer isOpen={medicalSpecialtyOpened} title={"Select your Medical Specialty"} close={() => setMedicalSpecialtyOpened(false)}>
                        <div className='p-4 space-y-3'>
                            <BringzzText tag='h5' className="font-normal">Please find down below the most common medical specialties. You can select more than one specialty. Please select all the ones which relates to you.</BringzzText>
                            <BringzzMultiSelect
                                onChange={handleMultiSelectChange}
                                state={{ checked: state.checked, unChecked: state.unChecked }}
                                className="divide-y"
                            >
                                {medicalSpecialties.map((specialty, index) => (
                                    <BringzzCheck key={index} value={specialty}>{specialty}</BringzzCheck>
                                ))}
                            </BringzzMultiSelect>
                            <BringzzInput 
                                onEnterPress={(newValue) => setMedicalSpecialties([newValue, ...medicalSpecialties])} 
                                placeholder='Other medical speciality'
                            />
                            <BringzzText tag='h5'>Please enter your medical specialty, in case it is not listed</BringzzText>
                            <BringzzButton
                                className='bg-magic-lilac w-full flex justify-center'
                                onClick={() => setMedicalSpecialtyOpened(false)}
                                disabled={!selectedMedicalSpecialties}
                            >
                                Confirm
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>
                    <BringzzBottomDrawer isOpen={medicalSpecialtyOpened} title={"Select your Medical Specialty"} close={() => setMedicalSpecialtyOpened(false)}>
                        <div className='p-4 space-y-3'>
                            <BringzzText tag='h5' className="font-normal">Please find down below the most common medical specialties. You can select more than one specialty. Please select all the ones which relates to you.</BringzzText>
                            <BringzzMultiSelect
                                onChange={handleMultiSelectChange}
                                state={{ checked: state.checked, unChecked: state.unChecked }}
                                className="divide-y"
                            >
                                {medicalSpecialties.map((specialty, index) => {
                                    return <BringzzCheck key={index} value={specialty}>{specialty}</BringzzCheck>
                                })}

                            </BringzzMultiSelect>
                            <BringzzInput onEnterPress={(newValue) => setMedicalSpecialties([newValue, ...medicalSpecialties])} placeholder='Other medical speciality'></BringzzInput>
                            <BringzzText tag='h5'>Please enter your medical specialty, in case it is not listed</BringzzText>
                            <BringzzButton
                                className='bg-magic-lilac w-full flex justify-center'
                                onClick={() => {
                                    setMedicalSpecialtyOpened(false)
                                }}
                                disabled={!selectedMedicalSpecialties}
                            >
                                Confirm
                            </BringzzButton>
                        </div>
                    </BringzzBottomDrawer>
                </div>
            </div >
        </BringzzPageContainer >
    );
};

export default ConsumerProfilePage;
